// Simplifies the low-stock message on cart drawer line items from "Only N units left" to "Only N
// left" — scoped to .cart-drawer__items specifically (the theme's shared locale string is left
// untouched, so PDP/collection/other templates keep their own wording). The cart drawer replaces its
// children wholesale on every cart change, so this observes document.body rather than a single
// container reference.
(function () {
  var UNITS_PATTERN = /\b(\d+)\s+units?\s+left\b/i;

  function simplify(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      if (UNITS_PATTERN.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(UNITS_PATTERN, '$1 left');
      }
    }
  }

  function scan() {
    document.querySelectorAll('.cart-drawer__items').forEach(simplify);
  }

  scan();

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
